/* Regnum variant gate.
   On product pages, if the URL has no ?variant= param (customer hasn't
   explicitly picked yet), force them to actively pick before adding to cart.

   Handles three forms of variant selector that Xtra uses:
     - <select name="options[...]">          (dropdown per option)
     - <input type="radio" name="options[...]"> (button per option group)
     - <input type="radio" name="variant-id"> (single radio set carrying the
       full variant id directly, used when Xtra is in "buttons" mode and
       options are flattened into one swatch list)
*/
(function () {
  'use strict';

  function init() {
    // Skip if URL already specifies a variant — customer picked deliberately.
    var url = new URL(window.location.href);
    if (url.searchParams.has('variant')) return;

    // Find all gateable inputs on the page
    var optionSelects = document.querySelectorAll('select[name^="options["]');
    var optionRadios = document.querySelectorAll('input[type="radio"][name^="options["]');
    var variantRadios = document.querySelectorAll('input[type="radio"][name="variant-id"]');

    if (optionSelects.length === 0 && optionRadios.length === 0 && variantRadios.length === 0) {
      return;
    }
    // Single-variant safety: only one variant-id radio and no option inputs.
    if (variantRadios.length === 1 && optionSelects.length === 0 && optionRadios.length === 0) {
      return;
    }

    // Group inputs by name. variant-id radios all share one group.
    var groups = {};
    function group(input) {
      if (!groups[input.name]) groups[input.name] = [];
      groups[input.name].push(input);
    }
    optionSelects.forEach(group);
    optionRadios.forEach(group);
    variantRadios.forEach(group);

    // Find the main ATC button. Xtra puts the variant swatches OUTSIDE the
    // cart-add form, so we don't scope to the form here.
    var atcButtons = document.querySelectorAll(
      'form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] button[name="add"], button.overlay-buy_button'
    );
    if (atcButtons.length === 0) return;

    var originalText = [];
    atcButtons.forEach(function (b) { originalText.push(b.innerHTML); });

    function labelFromName(name) {
      if (name === 'variant-id') return 'option';
      var m = name.match(/options\[(.+?)\]$/);
      if (!m) return 'option';
      var parts = m[1].split('-');
      return parts[parts.length - 1] || 'option';
    }

    // Clear current selections in every group
    Object.keys(groups).forEach(function (name) {
      var inputs = groups[name];
      var first = inputs[0];
      if (first.tagName === 'SELECT') {
        if (first.querySelector('option[data-regnum-placeholder="true"]')) return;
        var ph = document.createElement('option');
        ph.value = '';
        ph.textContent = 'Choose ' + labelFromName(name);
        ph.disabled = true;
        ph.selected = true;
        ph.setAttribute('data-regnum-placeholder', 'true');
        first.insertBefore(ph, first.firstChild);
        Array.prototype.slice.call(first.options).forEach(function (opt) {
          if (opt !== ph) opt.selected = false;
        });
        first.value = '';
      } else if (first.type === 'radio') {
        inputs.forEach(function (r) {
          r.checked = false;
          // Also remove any "selected" class from the wrapping label/li so
          // visual swatch highlight clears
          var lab = r.closest('label, li');
          if (lab) lab.classList.remove('selected', 'active', 'is-selected');
        });
      }
    });

    function allPicked() {
      var picked = true;
      Object.keys(groups).forEach(function (name) {
        var inputs = groups[name];
        var first = inputs[0];
        if (first.tagName === 'SELECT') {
          if (!first.value) picked = false;
        } else if (first.type === 'radio') {
          var any = inputs.some(function (r) { return r.checked; });
          if (!any) picked = false;
        }
      });
      return picked;
    }

    function updateAtc() {
      var ok = allPicked();
      atcButtons.forEach(function (btn, i) {
        if (ok) {
          btn.disabled = false;
          btn.classList.remove('regnum-gated');
          btn.innerHTML = originalText[i];
        } else {
          btn.disabled = true;
          btn.classList.add('regnum-gated');
          btn.innerHTML = 'Choose your options';
        }
      });
      // Toggle a body-level flag so CSS can hide variant-bound details
      // (stock, delivery line) while no variant is picked.
      if (ok) {
        document.body.classList.remove('regnum-gating');
      } else {
        document.body.classList.add('regnum-gating');
      }
    }

    updateAtc();

    var allInputs = [].concat(
      Array.prototype.slice.call(optionSelects),
      Array.prototype.slice.call(optionRadios),
      Array.prototype.slice.call(variantRadios)
    );
    allInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        // Let theme JS finish its own change-handling first
        setTimeout(updateAtc, 0);
      });
      // For radio swatches, also listen on parent label clicks since theme JS
      // may swallow the change event in some interaction paths.
      if (input.type === 'radio') {
        var lab = input.closest('label');
        if (lab) lab.addEventListener('click', function () { setTimeout(updateAtc, 50); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(init, 200);
    });
  } else {
    setTimeout(init, 200);
  }
})();
